export default function getMapLink( { address, city, latitude, longitude, state, zip } ) {
	const isIOS = /iPhone|iPad|iPod/i.test( navigator.platform );
	const locationString = `${address}, ${city}, ${state} ${zip}`;
	const latLngString = `${latitude},${longitude}`;

	if ( isIOS ) {
		return `//maps.apple.com/maps?q=${locationString}&ll=${latLngString}`;
	}

	return `//www.google.com/maps/dir/?api=1&travelmode=driving&destination=${locationString}`;
}
